module.exports = __webpack_public_path__ + "static/media/logo-cpapp.6d146fbe.png";